import { Moon, Sun } from 'lucide-react';
import type { ReactNode } from 'react';
import { LogoLockup } from '@/components/Logo';
import { useTheme } from '@/context/ThemeContext';

export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title?: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
}) {
  const { theme, toggleTheme } = useTheme();
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      background: 'var(--bg-app)',
      position: 'relative'
    }}>
      <button
        type="button"
        onClick={toggleTheme}
        title="Toggle theme"
        style={{
          position: 'absolute',
          top: '24px',
          right: '24px',
          width: '36px',
          height: '36px',
          borderRadius: 'var(--radius-md)',
          border: '1px solid var(--border-subtle)',
          background: 'var(--bg-surface)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          color: 'var(--text-secondary)'
        }}
      >
        {theme === 'light' ? <Moon size={18} /> : <Sun size={18} />}
      </button>

      <div style={{ width: '100%', maxWidth: '400px' }}>
        {/* The dial IS the O - the same lockup the app shell and the setup
            wizard render. This screen used to set the mark down beside the
            words as a separate badge, which reads as a logo next to a name
            rather than as the name, and is the one place the brand appeared
            unlocked. Kept animated: it is the first thing anyone sees. */}
        <div style={{ marginBottom: '32px', textAlign: 'center' }}>
          <span style={{ display: 'inline-flex', alignItems: 'baseline', gap: '0.28em' }}>
            <LogoLockup size={30} glow animated />
            <span style={{ fontSize: '30px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.01em', lineHeight: 1 }}>
              Sandbox
            </span>
          </span>
          {subtitle && (
            <div style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--text-muted)', marginTop: '10px' }}>
              {subtitle}
            </div>
          )}
        </div>

        {title && (
          <div style={{ marginBottom: '24px', textAlign: 'center' }}>
            <h1 style={{ fontSize: '1.5rem', fontWeight: 600, color: 'var(--text-primary)', letterSpacing: '-0.025em' }}>{title}</h1>
          </div>
        )}

        {children}
      </div>
    </div>
  );
}
